// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-panel-list-content {
  height: 100%;
  overflow: hidden;
}

.side-panel-list-item-content-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--input-element-gap);
}

.side-panel-list-item-label {
  text-overflow: ellipsis;
  overflow: hidden;
}

.side-panel-list-content,
.side-panel-list-scroll-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.side-panel-list-scroll-container {
  overflow-y: auto;
  overflow-x: hidden;
  gap: var(--side-panel-padding);
}

.side-panel-list-scroll-container,
.side-panel-list-fixed-bottom-container {
  padding: var(--side-panel-padding);
}

.side-panel-list-fixed-bottom-container {
  background-color: var(--light-blue-background-color);
  border-top: 1px solid var(--border-color);
}

.side-panel-list-footer {
  background-color: var(--light-blue-background-color);
}

.side-panel-list-footer-spacer {
  flex-grow: 1;
}

.side-panel-list-header-usericon > svg {
  margin-bottom: -1px;
}

.side-panel-list-item,
.side-panel-list-item-upper,
.side-panel-list-fixed-bottom-item {
  display: flex;
  gap: var(--dialog-element-gap);
  font-size: var(--font-size-l);
  word-wrap: none;
  white-space: nowrap;

  > span {
    flex-grow: 1;
  }
}

.side-panel-list-item-upper-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.side-panel-list-item-upper-text-sharing {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap-small);
  text-overflow: ellipsis;
  align-items: center;
  font-size: var(--font-size-m);

  > button {
    margin-top: 1px;
  }
}

.side-panel-list-item-upper,
.side-panel-list-fixed-bottom-item {
  align-items: center;
}

.side-panel-list-item-upper span,
.side-panel-list-fixed-bottom-item span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.side-panel-list-item,
.side-panel-list-fixed-bottom-item {
  flex-direction: column;
  padding: calc(var(--side-panel-padding) / 2);
  border-radius: var(--dialog-border-radius);
}

.side-panel-list-item:hover,
.side-panel-list-item-highlighted {
  background-color: var(--light-grey);
}

.side-panel-list-item-selected {
  background-color: var(--blue-background-color);
}

.side-panel-list-item-avatar {
  border: 1px solid var(--border-color);
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.side-panel-list-item-name-far-away-in-hierarchy {
  color: #4d5258;
}

.side-panel-list-item-avatar,
.side-panel-list-item-avatar > img {
  width: var(--input-element-height-large);
  height: var(--input-element-height-large);
  border-radius: var(--input-element-height-large);
}

.side-panel-list-item-avatar > video {
  height: var(--input-element-height-large);
  left: 50%;
  transform: translateX(-50%);
  position: relative;
}

.side-panel-list-item-avatar-speaking {
  -webkit-box-shadow: 0px 0px 10px 2px var(--warn-color);
  box-shadow: 0px 0px 10px 2px var(--warn-color);
  transition: all 0.5s ease-out;
}

.side-panel-list-item-lower {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--input-element-gap);
  font-size: var(--font-size-m);
}

.side-panel-list-item-mute-button {
  min-width: unset;
}

.side-panel-list-item-avatar-mic {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  stroke: var(--dialog-background-color);
  stroke-opacity: 0.75;
  stroke-width: 20;
  font-size: var(--font-size-xl);
}

.side-panel-list-empty {
  font-size: var(--font-size-l);
  display: flex;
  flex-direction: row;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/side-panels/side-panel-list.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,oDAAoD;EACpD,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;;EAEnB;IACE,YAAY;EACd;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;;EAE7B;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;EACxC,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;EACzC,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".side-panel-list-content {\n  height: 100%;\n  overflow: hidden;\n}\n\n.side-panel-list-item-content-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--input-element-gap);\n}\n\n.side-panel-list-item-label {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.side-panel-list-content,\n.side-panel-list-scroll-container {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.side-panel-list-scroll-container {\n  overflow-y: auto;\n  overflow-x: hidden;\n  gap: var(--side-panel-padding);\n}\n\n.side-panel-list-scroll-container,\n.side-panel-list-fixed-bottom-container {\n  padding: var(--side-panel-padding);\n}\n\n.side-panel-list-fixed-bottom-container {\n  background-color: var(--light-blue-background-color);\n  border-top: 1px solid var(--border-color);\n}\n\n.side-panel-list-footer {\n  background-color: var(--light-blue-background-color);\n}\n\n.side-panel-list-footer-spacer {\n  flex-grow: 1;\n}\n\n.side-panel-list-header-usericon > svg {\n  margin-bottom: -1px;\n}\n\n.side-panel-list-item,\n.side-panel-list-item-upper,\n.side-panel-list-fixed-bottom-item {\n  display: flex;\n  gap: var(--dialog-element-gap);\n  font-size: var(--font-size-l);\n  word-wrap: none;\n  white-space: nowrap;\n\n  > span {\n    flex-grow: 1;\n  }\n}\n\n.side-panel-list-item-upper-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.side-panel-list-item-upper-text-sharing {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap-small);\n  text-overflow: ellipsis;\n  align-items: center;\n  font-size: var(--font-size-m);\n\n  > button {\n    margin-top: 1px;\n  }\n}\n\n.side-panel-list-item-upper,\n.side-panel-list-fixed-bottom-item {\n  align-items: center;\n}\n\n.side-panel-list-item-upper span,\n.side-panel-list-fixed-bottom-item span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.side-panel-list-item,\n.side-panel-list-fixed-bottom-item {\n  flex-direction: column;\n  padding: calc(var(--side-panel-padding) / 2);\n  border-radius: var(--dialog-border-radius);\n}\n\n.side-panel-list-item:hover,\n.side-panel-list-item-highlighted {\n  background-color: var(--light-grey);\n}\n\n.side-panel-list-item-selected {\n  background-color: var(--blue-background-color);\n}\n\n.side-panel-list-item-avatar {\n  border: 1px solid var(--border-color);\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.side-panel-list-item-name-far-away-in-hierarchy {\n  color: #4d5258;\n}\n\n.side-panel-list-item-avatar,\n.side-panel-list-item-avatar > img {\n  width: var(--input-element-height-large);\n  height: var(--input-element-height-large);\n  border-radius: var(--input-element-height-large);\n}\n\n.side-panel-list-item-avatar > video {\n  height: var(--input-element-height-large);\n  left: 50%;\n  transform: translateX(-50%);\n  position: relative;\n}\n\n.side-panel-list-item-avatar-speaking {\n  -webkit-box-shadow: 0px 0px 10px 2px var(--warn-color);\n  box-shadow: 0px 0px 10px 2px var(--warn-color);\n  transition: all 0.5s ease-out;\n}\n\n.side-panel-list-item-lower {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: var(--input-element-gap);\n  font-size: var(--font-size-m);\n}\n\n.side-panel-list-item-mute-button {\n  min-width: unset;\n}\n\n.side-panel-list-item-avatar-mic {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  stroke: var(--dialog-background-color);\n  stroke-opacity: 0.75;\n  stroke-width: 20;\n  font-size: var(--font-size-xl);\n}\n\n.side-panel-list-empty {\n  font-size: var(--font-size-l);\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
